import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import useClickOutside from "../../../../../hooks/useClickOutside";
import { EATING_TAGS } from "./constants";

const TagsDrawer = ({ isOpen, tagsData, closeTagsDrawer }) => {
  const { t } = useTranslation("athlete-portal");
  const dropdownRef = useRef(null);
  useClickOutside(
    dropdownRef,
    () => {
      closeTagsDrawer();
    },
    isOpen
  );
  return isOpen ? (
    <div
      className="tags-drawer-content"
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          closeTagsDrawer();
        }
      }}
      tabIndex={0}
      role="dialog"
      aria-label={t("mealPhotosPage.reasonsForEating")}
    >
      <header className="tags-drawer-header">
        <h3>{t("mealPhotosPage.reasonsForEating")}</h3>
        <button
          className="tags-drawer-close"
          onClick={closeTagsDrawer}
          aria-label={t("mealPhotosPage.closeReasonsDrawer")}
        >
          <SvgIcon noFilterOnLight={true} src="/img/new-icons/red-cross.svg" />
        </button>
      </header>

      <div className="tags-list">
        {tagsData.tags.length === 0 ? (
          <p className="no-tags-message">{t("mealPhotosPage.noReasonsRecorded")}</p>
        ) : (
          tagsData.tags.map((tagData, index) => (
            <div key={index} className="tag-item">
              <div className="tag-label-container">
                <span className="text-3xl">
                  {EATING_TAGS.find((t) => t.text === tagData.tag)?.emoji}{" "}
                </span>
                {tagData.tag.charAt(0).toUpperCase() + tagData.tag.slice(1)}
              </div>
              <div className="tag-bar-container">
                <div
                  className="tag-bar"
                  style={{ width: `${tagData.percentage}%` }}
                />
              </div>
              <span className="tag-percentage">{tagData.percentage}%</span>
            </div>
          ))
        )}
      </div>
    </div>
  ) : null;
};

export default TagsDrawer;
